'use client';

import { useCallback, useRef } from 'react';
import { hubspotAPIClient, type HubSpotContactFormData } from '../../infrastructure/hubspot';
import { debounce } from 'es-toolkit';

const DEBOUNCE_MS = 1000;

export const useHubSpotService = () => {
  const lastSubmittedRef = useRef<string | null>(null);

  const submitContactForm = useCallback(
    debounce(async (data: HubSpotContactFormData) => {
      const dataHash = `${data.name}|${data.email}|${data.phone}`;

      if (lastSubmittedRef.current === dataHash) {
        return;
      }

      try {
        await hubspotAPIClient.submitContactForm(data);
        lastSubmittedRef.current = dataHash;
      } catch (error) {
        console.error('[HubSpot] Failed to submit contact form:', error);
      }
    }, DEBOUNCE_MS),
    [],
  );

  return {
    submitContactForm,
  };
};

